import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { OnboardingService } from '@services/onboarding/onboarding.service';
import { AppConfig } from '../app.config';

const onboardingPages: string[] = ['/login', '/logout', '/language', '/onboarding/number', '/onboarding/otp'];
const exceptionUrls: string[] = ['/user/instantcheckup', '/logout', '/empty', 'force', 'iframe'];

/**
 * If user onboarding is not complete then redirect user to page where they left the app.
 *
 * @param route
 * @param state
 * @returns
 */
export const onboardingGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const isExceptionUrl: boolean = exceptionUrls.includes(route.url.toString());
  const connectionService: ConnectionService = inject(ConnectionService);
  const experimentService: ExperimentService = inject(ExperimentService);
  const onboardingServiceProvider = inject(OnboardingService);
  const user = connectionService.getActingUser();
  const appConfig = inject(AppConfig);

  if (user.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED) return true;
  if (isExceptionUrl) return true;
  if (connectionService.isInternalUser()) return true;

  await experimentService.experimentsLoaded;
  const validateOnboardingUrl: OnboardingPageUrl | null = onboardingServiceProvider.getService().validateOnboarding();
  return validateOnboardingUrl ? createUrlTreeFromSnapshot(route, [validateOnboardingUrl]) : true;
};
